export const getAvailableProtocols = (state) => state.protocolState.availableProtocols;

export const getLastOpenedProtocol = (state) => state.protocolState.lastOpenedProtocol;

export const getLastProtocolCheckpoint = (state) => state.protocolState.lastProtocolCheckpoint;

export const selectProtocolCheckpointHistoryId = (state) => state.protocolState.lastProtocolCheckpoint?.historyId;

export const selectFavoriteProtocols = (state) => state.protocolState.favoriteProtocols;

export const selectOpenedProtocolIsEjectToCaddy = (state) => state.protocolState.lastOpenedProtocol?.isEjectToCaddy;
